import React, { useCallback, useRef, useState } from 'react';
import classnames from 'classnames';
import { getSrcSet } from '../../../DeviationViews/Dumbo/Image/_helpers';
import ZoomModal from './ZoomModal';
import { scaleToSize } from '../../_helpers';
import { useFullview } from './hooks/useFullview';
import ddt from '@wix/da-ddt';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import AddVideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import numeral from 'numeral';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from './Image.scss';
export const ImageFullView = ({ width, height, deviation, isZoomed, onEnterZoomMode, onExitZoomMode })=>{
    const imgRef = useRef(null);
    const [playButtonShown, setPlayButtonShown] = useState(true);
    const { previewFile, srcFile, isFullscreen, isPixel, canZoom, src, srcSet, sizes, isLargeGif, isGif } = useFullview({
        stageWidth: width !== null && width !== void 0 ? width : 0,
        stageHeight: height !== null && height !== void 0 ? height : 0,
        deviation
    });
    // Alert if we ever render the src because we want to always render the srcset
    const fvChecker = (e)=>{
        if (e.target.currentSrc === srcFile.src && !isGif && srcFile.src !== previewFile.src) {
            ddt.alert('deviation', 'Rendered fullview when we should not', [
                'perf'
            ], {
                deviation,
                srcFile,
                previewFile,
                srcSet,
                width,
                height
            });
        }
    };
    const handleClick = useCallback((e)=>{
        if (isLargeGif && imgRef.current && playButtonShown) {
            imgRef.current.srcset = ''; // force the src to show
            setPlayButtonShown(false);
            return;
        }
        canZoom && onEnterZoomMode && onEnterZoomMode();
    }, [
        canZoom,
        isLargeGif,
        onEnterZoomMode,
        playButtonShown
    ]);
    if (!previewFile) {
        return null;
    }
    const size = scaleToSize(previewFile, {
        width,
        height
    });
    var _deviation_title;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isFullscreen && s['fullscreen']),
        style: {
            width,
            height
        }
    }, isZoomed && srcFile && /*#__PURE__*/ React.createElement(ZoomModal, {
        src: srcFile.src,
        srcSet: getSrcSet(deviation),
        width: srcFile.width,
        height: srcFile.height,
        isPixel: isPixel,
        onClose: onExitZoomMode
    }), isLargeGif && playButtonShown && /*#__PURE__*/ React.createElement("div", {
        className: s['gif-player'],
        style: size
    }, /*#__PURE__*/ React.createElement(IconButton, {
        icon: AddVideoIcon,
        size: 'large',
        onClick: handleClick
    }, "Play Gif"), /*#__PURE__*/ React.createElement("div", null, "Play large GIF (", numeral(srcFile.filesize).format('0.00b'), ")")), /*#__PURE__*/ React.createElement("img", {
        key: `fv-${deviation.deviationId}`,
        ref: imgRef,
        alt: (_deviation_title = deviation.title) !== null && _deviation_title !== void 0 ? _deviation_title : '',
        "aria-hidden": "true",
        className: classnames(s['image'], isPixel && s['pixel'], canZoom && s['zoomable']),
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        style: size,
        onClick: handleClick,
        onLoad: fvChecker,
        fetchpriority: 'high'
    }));
};
ImageFullView.displayName = 'ImageFullView';
export default ImageFullView;
